const React = require('react');

module.exports = ({
  description,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={'f25 cF lh lts.005em rlv st-1 ' + (props.className || '')}
    >
      {
        description ? (
          <>
            <div>{children}</div>
            <div className="rlv">
              <div
                className="o50 f12 abs sh st2"
              >{description}</div>
            </div>
          </>
        ) : children
      }
    </div>
  );
};
